import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';

const CHAVES = [
  { chave: 'EDITAR_ID_PROPRIO', label: 'Editar com ID Próprio', tipo: 'select', opcoes: [
    { valor: 'S', label: 'Sim' },
    { valor: 'N', label: 'Não' },
  ]},
  { chave: 'VISUALIZAR_TIPO', label: 'Visualização de Documentos', tipo: 'select', opcoes: [
    { valor: 'WORD_PDF', label: 'Word e PDF' },
    { valor: 'WORD', label: 'Apenas Word' },
    { valor: 'PDF', label: 'Apenas PDF' },
  ]},
  { chave: 'EDITAR_DPE', label: 'Editar DPE', tipo: 'select', opcoes: [
    { valor: 'S', label: 'Sim' },
    { valor: 'N', label: 'Não' },
  ]},
  { chave: 'EXIBIR_ID', label: 'Identificador em Relatórios', tipo: 'select', opcoes: [
    { valor: 'PADRAO', label: 'Padrão (ID Próprio ou ID)' },
    { valor: 'ID_GERAL', label: 'ID Geral' },
    { valor: 'ID_PROPRIO', label: 'ID Próprio' },
  ]},
  { chave: 'EDITAR_ITEM', label: 'Editar Itens com Ordem/Pedido', tipo: 'select', opcoes: [
    { valor: 'S', label: 'Sim' },
    { valor: 'N', label: 'Não' },
  ]},
  { chave: 'REVERTER_ENTREGA', label: 'Reverter Entrega de Itens', tipo: 'select', opcoes: [
    { valor: 'S', label: 'Sim' },
    { valor: 'N', label: 'Não' },
  ]},
];

function ParametroEntidadeModal({ show, onClose, onSave, data: entidade }) {
  const [parametros, setParametros] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (show && entidade) {
      axios.get(`${API_BASE_URL.PARAMETRO}/entidade/${entidade.idEntidade}/map`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(res => {
          const vals = {};
          for (const c of CHAVES) {
            vals[c.chave] = res.data[c.chave] || '';
          }
          setParametros(vals);
        })
        .catch(() => {
          const vals = {};
          for (const c of CHAVES) {
            vals[c.chave] = '';
          }
          setParametros(vals);
        });
    }
  }, [show, entidade]);

  const handleChange = (chave, valor) => {
    setParametros(prev => ({ ...prev, [chave]: valor }));
  };

  const handleSave = () => {
    if (!entidade) return;
    setIsSaving(true);
    axios.post(
      `${API_BASE_URL.PARAMETRO}/entidade/${entidade.idEntidade}/salvar-todos`,
      parametros,
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .then(() => {
        if (onSave) onSave();
        if (onClose) onClose();
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => setIsSaving(false));
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
      <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header text-white" style={{ background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)', padding: '0.5rem 1rem' }}>
            <h6 className="modal-title mb-0">
              <i className="bi bi-sliders me-2"></i>
              Parâmetros
            </h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={isSaving} aria-label="Fechar"></button>
          </div>
          <div className="modal-body">
            <div className="card card-body bg-light py-2 mb-3">
              <div className="d-flex justify-content-between align-items-center">
                <strong className="small">{entidade?.nome}</strong>
                <small className="text-muted">{entidade?.idEntidade}</small>
              </div>
            </div>
            {CHAVES.map(c => (
              <div key={c.chave} className="mb-3">
                <label className="form-label fw-semibold">{c.label}</label>
                <select
                  className="form-select form-select-sm"
                  value={parametros[c.chave] || ''}
                  onChange={e => handleChange(c.chave, e.target.value)}
                >
                  <option value="">--- Selecione ---</option>
                  {c.opcoes.map(o => (
                    <option key={o.valor} value={o.valor}>{o.label}</option>
                  ))}
                </select>
              </div>
            ))}
          </div>
          <div className="modal-footer py-2">
            <button className="btn btn-secondary me-2" onClick={onClose} disabled={isSaving}>Cancelar</button>
            <button className="btn btn-primary" onClick={handleSave} disabled={isSaving}>
              {isSaving ? (
                <><span className="spinner-border spinner-border-sm me-1"></span>Salvando...</>
              ) : (
                <><i className="bi bi-floppy me-1"></i>Salvar</>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ParametroEntidadeModal;
